$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

jQuery(function ($) {

    // --- NAV ---
    
    $(".nav-search").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-search-modal .search-close").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-responsive").removeClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $(".burger").removeClass("active")
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart-modal .cart-close").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-burger, .nav-responsive-overlay").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $(".nav-responsive-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport"); 
    });
    $(".nav-cart-overlay").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    
    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-responsive ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        }
    });
    
    $(".page-single article .gallery br").remove();


    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });


    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    
    // --- WOOCOMMERCE ---

    $(document).on('click', '.product-quantity-minus', function(e) {
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        var newQuantity = (currentQuantity >= 1) ? (currentQuantity - 1) : 0;
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });

    $(document).on('click', '.product-quantity-plus', function(e) {
        var max_quantity = 99999;
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        if(isNaN(currentQuantity)) currentQuantity = 0;
        var newQuantity = (currentQuantity >= max_quantity) ? max_quantity : (currentQuantity + 1);
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });
    
    $(document.body).trigger('wc_fragment_refresh');

});



const sectionHeader = document.querySelector('.section--header');
const sectionHeroHome = document.querySelector('.section--hero--home');

if(sectionHeader && sectionHeroHome) {
    const sectionHeight = sectionHeader.offsetHeight;
    sectionHeroHome.style.marginTop = `-${sectionHeight}px`;
    sectionHeroHome.style.paddingTop = `${sectionHeight}px`;
    sectionHeroHome.style.paddingBottom = `${sectionHeight}px`;
}

